import { getTerminalPrefix, isSingleAppDomain, isZongHengApp, isTtDaHuoApp } from '@/utils/singleApp'

export const getRootServer = () => {
    const hostname = location.hostname
    const hostArr = hostname.split('.')
    return hostArr.splice(hostArr.length - 2, 2).join('.')
}

// eslint-disable-next-line complexity
export const getTerminaDomain = terminalName => {
    if (!terminalName || location.host.startsWith('localhost') || location.host.startsWith('192.168')) {
        return location.origin
    }

    let rootServer = getRootServer()

    // 天天打货，注意顺序，纵横版也存在寻合作独立域名（寻合作是没有account的，使用的是主站点的）
    if (isTtDaHuoApp) {
        rootServer = 'scm121.com'
    }

    // 市场版/纵横版
    if (isSingleAppDomain || isZongHengApp) {
        const prefix = getTerminalPrefix(terminalName)

        switch (terminalName) {
            case PROJECT_CONFIG.supplierTerminalName:
                return `https://${prefix}.${rootServer}`
            case PROJECT_CONFIG.channelTerminalName:
                return `https://${prefix}.${rootServer}`
            case PROJECT_CONFIG.accountTerminalName:
                return `https://${prefix}.${rootServer}`
            case PROJECT_CONFIG.towerTerminalName:
                return `https://${PROJECT_CONFIG.towerFrontHostPrefix}.${rootServer}`
            default:
                return ''
        }
    }

    // 默认应用
    if (
        PROJECT_CONFIG.terminalName === PROJECT_CONFIG.adminTerminalName ||
        PROJECT_CONFIG.terminalNameSecond === PROJECT_CONFIG.sqmallTerminalName
    ) {
        rootServer = 'scm121.com'
    }

    if (terminalName === PROJECT_CONFIG.sqmallTerminalName) {
        rootServer = 'sursung.com'
    }

    switch (terminalName) {
        case PROJECT_CONFIG.supplierTerminalName:
            return `https://${PROJECT_CONFIG.supplierHostPrefix}.${rootServer}`
        case PROJECT_CONFIG.channelTerminalName:
            return `https://${PROJECT_CONFIG.channelHostPrefix}.${rootServer}`
        case PROJECT_CONFIG.accountTerminalName:
            return `https://${PROJECT_CONFIG.accountHostPrefix}.${rootServer}`
        case PROJECT_CONFIG.towerTerminalName:
            return `https://${PROJECT_CONFIG.towerFrontHostPrefix}.${rootServer}`
        case PROJECT_CONFIG.sqmallTerminalName:
            return `https://${PROJECT_CONFIG.sqmallHostPrefix}.${rootServer}`
        case PROJECT_CONFIG.goodsTerminalName:
            return `https://${PROJECT_CONFIG.goodsHostPrefix}.${rootServer}`
        case PROJECT_CONFIG.darenTerminalName:
            return `https://${PROJECT_CONFIG.darenHostPrefix}.${rootServer}`
        default:
            return ''
    }
}

/** local 表示子应用独立访问，默认角色是供应商 */
export function getLocalTerminalDomain(terminalName) {
    if (location.host.startsWith('dev.') || location.host.startsWith('localhost')) {
        // return 'https://testsc.scm121.com'
        return MASTER_IS_CHANNEL ? 'https://testgyl.scm121.com' : 'https://testsc.scm121.com'
    }
    const defaultTerminalName = MASTER_IS_CHANNEL
        ? PROJECT_CONFIG.channelTerminalName
        : PROJECT_CONFIG.supplierTerminalName
    return getTerminaDomain(terminalName || defaultTerminalName)
}
